import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { paths, routes } from 'data/routes';

import * as S from './SeasonAndZones.styles';
import { Seasons } from './components/Seasons/Seasons';
import { Zones } from './components/Zones/Zones';

export const SeasonsAndZones = () => {
  const params = Object.values(useParams());
  const isSeasons = params.some((param) => param === 'seasons');
  const isZones = params.some((param) => param === 'zones');

  return (
    <S.MainContainer>
      {(isSeasons || isZones || params[0] === '') && (
        <S.navWrapper>
          <S.navBtn
            motive={isSeasons ? 'm4' : 'm1'}
            asLink
            textTransform="uppercase"
            to={routes.seasons}
          >
            seasons
          </S.navBtn>
          <S.navBtn
            motive={isZones ? 'm4' : 'm1'}
            asLink
            textTransform="uppercase"
            to={routes.zones}
          >
            zones
          </S.navBtn>
        </S.navWrapper>
      )}
      <Routes>
        <Route index element={<Navigate to={paths.seasons} />} />
        <Route path={`${paths.seasons}/*`} element={<Seasons />} />
        <Route path={`${paths.zones}/*`} element={<Zones />} />
      </Routes>
    </S.MainContainer>
  );
};
